import { render, staticRenderFns } from "./LightboxDownloadNav.vue?vue&type=template&id=a752a8b6&scoped=true&"
var script = {}
import style0 from "./LightboxDownloadNav.vue?vue&type=style&index=0&id=a752a8b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a752a8b6",
  null
  
)

export default component.exports